<script setup lang="ts">
import languageJSON from '@/lang/index.json'
import type { Assortment, Language } from '@/types'
import { useI18n } from 'vue-i18n'

const { locale } = useI18n()

const props = defineProps<{ assortment: Assortment; isLastElement: boolean }>()
const language = languageJSON[locale.value as unknown as Language]
const assortment = language[props.assortment.index as keyof typeof language]
</script>
<template>
  <span>
    {{ isLastElement ? assortment : `${assortment},&nbsp;` }}
  </span>
</template>
